/**
 * Tailwind CSS implementation of Text component
 * Uses Seeds text CSS classes from text.css
 */

import React from "react";
import type { TypeTextProps } from "./TextTypes";

// Utility for merging class names properly
function cn(
  ...inputs: (string | undefined | null | false | Record<string, boolean>)[]
): string {
  const classes: string[] = [];

  for (const input of inputs) {
    if (!input) continue;

    if (typeof input === "string") {
      classes.push(input);
    } else if (typeof input === "object") {
      for (const [key, value] of Object.entries(input)) {
        if (value) {
          classes.push(key);
        }
      }
    }
  }

  return classes.join(" ");
}

export const TextTailwind = React.forwardRef<HTMLSpanElement, TypeTextProps>(
  (
    { as, truncated, breakWord, isItalicized, className, children, ...rest },
    ref
  ) => {
    const Component = (as || "span") as any;

    const classes = cn(
      "seeds-text",
      {
        "seeds-text-italic": !!isItalicized,
        "seeds-text-truncated": !!truncated,
        "seeds-text-break-word": !!breakWord,
      },
      className
    );

    return (
      <Component ref={ref} className={classes} {...rest}>
        {children}
      </Component>
    );
  }
);

TextTailwind.displayName = "TextTailwind";
